module.exports = __webpack_public_path__ + "img/icon-house-builder.7988dfeb.svg";